import { ApiOrgType } from '#/modules/listing/orgs/api/types/ApiOrgType';

type Props = {
  orgType: ApiOrgType;
};

export function getOrgDetailFields({ orgType }: Props) {
  let fields: { fields: string[] }[] = [];

  if (orgType === ApiOrgType.CONSULTANT) {
    fields = [
      {
        fields: ['services'],
      },
      {
        fields: ['clients'],
      },
    ];
  }

  if (orgType === ApiOrgType.RECRUITER) {
    fields = [
      {
        fields: ['clients'],
      },
    ];
  }

  if (orgType === ApiOrgType.CORPORATION) {
    fields = [
      {
        fields: ['isSocialEnterprise'],
      },
      {
        fields: ['isBCorp'],
      },
      {
        fields: ['isHospiceProvider'],
      },
      {
        fields: ['relatedJobAreas'],
      },
      {
        fields: ['relatedJobCount'],
      },
    ];
  }

  if (orgType === ApiOrgType.CORPORATION) {
    fields.push({ fields: ['orgSize'] });
  }

  if (orgType === ApiOrgType.COMMUNITY) {
    fields = [{ fields: ['howToGetInvolved'] }, { fields: ['timeActive'] }];
  }

  if (fields.length > 0) {
    fields = [
      {
        fields: ['orgTypeDetailsIntro'],
      },
    ].concat(fields);
  }
  return fields;
}
